const noop = () => {};
export default class BrowserStorage {
  constructor(rootKey = 'TESTING_ONLY_SESSION_DATA', options) {
    this.options = {
      rootKey,
      storage: options.persist ? global.localStorage : global.sessionStorage,
      serialize: value => typeof value === 'string' ? value : JSON.stringify(value),
      deserialize: JSON.parse,
      ...options
    };
    this.setItem = this.setItem.bind(this);
    this.getItem = this.getItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.getLastError = this.getLastError.bind(this);

    // If code is run in a server environment
    // noop to avoid storing error state
    if (typeof window === 'undefined') {
      this.setItem = noop;
      this.getItem = noop;
      this.removeItem = noop;
      this.getLastError = noop;
    }
  }
  catchError(func, ...args) {
    delete this.lastError;
    try {
      return func(...args);
    } catch (e) {
      this.lastError = e;
    }
    return null;
  }
  getItem() {
    return this.catchError(() => this.options.deserialize(this.options.storage.getItem(this.options.rootKey)));
  }
  setItem(value) {
    /* storage.setItem() may throw an exception if the storage is full in addition, Safari sets quota to 0 bytes in
         private mode */
    return this.catchError(() => this.options.storage.setItem(this.options.rootKey, this.options.serialize(value)));
  }
  removeItem() {
    return this.catchError(() => this.options.storage.removeItem(this.options.rootKey));
  }
  getLastError() {
    return this.lastError;
  }
}